// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ReturnsRouteImport } from './routes/returns'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as LegalNoticeRouteImport } from './routes/legal-notice'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CheckoutReturnRouteImport } from './routes/checkout.return'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const ReturnsRoute = ReturnsRouteImport.update({
            id: '/returns',path: '/returns',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const LegalNoticeRoute = LegalNoticeRouteImport.update({
            id: '/legal-notice',path: '/legal-notice',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const CheckoutReturnRoute = CheckoutReturnRouteImport.update({
            id: '/checkout/return',path: '/checkout/return',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,CookiesRoute: CookiesRoute,LegalNoticeRoute: LegalNoticeRoute,PrivacyRoute: PrivacyRoute,ReturnsRoute: ReturnsRoute,TermsRoute: TermsRoute,CheckoutReturnRoute: CheckoutReturnRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)